/*
 * Houses all locale-specific settings for assortments. Eventually this will move to live in the backend powered
 * by a service
 */

// EXPERIMENT_MARKER=LOW_ATV_UI
// Note that packagesList data under both the grid section
// and the SIGNUP_PAGE section seem like they are not being used
// We will clean this up after the experiment

import { gettext } from '@eb/i18n';
import {
    AR_LOCALE,
    AT_LOCALE,
    AU_LOCALE,
    BR_LOCALE,
    CA_LOCALE,
    CL_LOCALE,
    CO_LOCALE,
    DE_CH_LOCALE,
    DE_LOCALE,
    DK_LOCALE,
    ES_LOCALE,
    FI_LOCALE,
    FR_CH_LOCALE,
    FR_LOCALE,
    GB_LOCALE,
    HK_LOCALE,
    IE_LOCALE,
    IT_LOCALE,
    MX_LOCALE,
    NL_LOCALE,
    NO_LOCALE,
    NZ_LOCALE,
    PE_LOCALE,
    PT_LOCALE,
    SE_LOCALE,
    SG_LOCALE,
    US_LOCALE,
} from '@eb/intl';
import {
    FINE_PRINT_WITH_FIXED_FEE,
    FINE_PRINT_WITH_FIXED_FEE_NZ,
    OVERVIEW_PAGE,
    PACKAGE_COMPARISON_PAGE,
    PACKAGE_ONE,
    PACKAGE_ONE_PAGE,
    PACKAGE_SELECTION_PAGE,
    PACKAGE_THREE,
    PACKAGE_THREE_PAGE,
    PACKAGE_TWO,
    PACKAGE_TWO_PAGE,
    PER_PAID_TICKET_WITHOUT_FINE_PRINT,
    PRICE_PER_PAID_TICKET,
    PRICING_PAGE,
    SIGNUP_PAGE,
} from './main';
import {
    ESSENTIALS_DESCRIPTION,
    FREE_ALWAYS_FREE_FEATURE,
    ONSITE_PLANNING,
    ORGANIZER_APP_FEATURE,
    PASS_FEES_ON_SECONDARY_HEADER,
    PREMIUM_DESCRIPTION,
    PRICE_DESCRIPTION,
    PROFESSIONAL_DESCRIPTION,
    RULE_DAYOF,
    STAFFING_FEATURE,
    UK_PROFESSIONAL_DESCRIPTION,
} from './overview';
import { appendFinePrintSignifier } from '../containers/utils';
import * as signupFeatures from './signupFeatures';
import {
    CHANGE_PACKAGE,
    CHANGE_PACKAGE_AU,
    FREE_OPTION_AU,
    FREE_OPTION_NEW_TLDS,
    PACKAGE_DIFFER,
    PACKAGE_DIFFER_AU,
    PAY_FEES,
    PAY_FEES_AU,
    PAY_FEES_NEW_TLDS,
    PAYMENT_OPTIONS,
    PAYMENT_OPTIONS_AU,
    PAYMENT_OPTIONS_NEW_TLDS,
    PRIVATE_EVENT,
    PRIVATE_EVENT_AU,
    TICKET_TYPE,
    TICKET_TYPE_AU,
    TICKETING_ESSENTIALS,
    TICKETING_ESSENTIALS_AU,
} from './faqs';
import {
    BASIC_TICKETING,
    BRAND_PAGES,
    CHECKOUT_WIDGET_B,
    CUSTOM_REGISTRATION,
    CUSTOMER_SUPPORT,
    DETAILED_ANALYTICS_C,
    EVERYTHING_IN_PROFESSIONAL,
    INCLUDE_ESSENTIALS,
    INCLUDE_ESSENTIALS_WITH_EPP,
    INCLUDE_PROFESSIONAL,
    INSTALLMENT,
    INSTALLMENT_PAYMENTS,
    INTEGRATIONS_B,
    LIVE_CHAT_24_7_SUPPORT,
    ORGANIZER_MOBILE_APP,
    PACKAGE_ONE_FEATURES,
    PACKAGE_ONE_FEATURES_AU_V2,
    PACKAGE_THREE_FEATURES_US,
    PACKAGE_THREE_GERMAN_FEATURES,
    PACKAGE_TWO_FEATURES_ALL,
    PACKAGE_TWO_GERMAN_FEATURES,
    PARTNER_SITES,
    PRODUCT_TRAINING,
    RENT_EQUIPMENT,
    RENTAL_EQUIPMENT,
    REPORTING_ESSENTIALS,
    RESERVED_SEATING,
    TEAM_ACCESS,
    TEAM_PERMISSIONS_B,
    TICKET_FEES_PAYMENT_PROCESSING,
    TRAINING_AND_SUPPORT_B,
    UNLIMITED_TICKET_TYPES,
    WHITE_LABELING_B,
} from './features';
import {
    ABRADI_SP,
    ARC_FOR_UNSW,
    ASISTEM_RRHH,
    AWESOME_INC_U,
    BEER_INCIDER,
    BEYOND_THE_VALLEY,
    BITS_AND_PRETZELS,
    BITS_AND_PRETZELS_DETAIL,
    BOTTLE_SHOP_CONCEPTS,
    CASA_COMIGO,
    CENTRO_COMERICAL,
    CHESS_BOXING,
    COMUNIDADE_DAS_NACOES,
    CONAACUP,
    CONVENCIONES_WALKERS,
    CRESCENT_CITY_CLASSIC,
    DANCE_411,
    DROVET,
    FORRO_DA_LUA_CHEIA,
    FUNDACION_ELEGI_SONREIR,
    FUNDACION_MEDIAR,
    GFNY,
    HERNAN_CASCIARI,
    INTERATIONAL_GAMES_WEEK,
    LOVES_DATA_CONFERENCE,
    MAKER_FAIRE,
    NATIONAL_SAWDUST,
    NEW_ME,
    OPEN_SHIMANO,
    PAYONEER,
    PLUS_NETWORK,
    QUEREMOS,
    RHYTHM_AND_VINES,
    SB_CONGRESOS,
    SENSEDIA,
    SOCIAL_MEDIA_WEEK_SP,
    SUPERLOGICA,
    TECH_OPEN_AIR,
    TECH_OPEN_AIR_DETAIL,
    TED_X_MELBOURNE,
    THE_YOGA_EXPO,
    THICK_AS_THIEVES,
    TMX,
    TRIANONS,
    WEB_DIRECTIONS,
    XLETIX,
    YAH_YAHS,
    YMCA,
    ZUM_BRAZIL_EVENTOS,
} from './testimonials';
import {
    PAYMENT_PROCESSING_US_UK_CA_AU,
    TICKET_TYPES,
} from './featuresComparison';
import {
    BRANDED_PAGES,
    CUSTOMIZABLE_CHECKOUT_FORMS,
    DETAIL_SALES_ANALYTICS,
    LISTING_PARTNER_SITES,
    ONSITE_RENTAL_SUPPORT,
    PACKAGE_THREE_FEATURES_A_AR_BR,
    PACKAGE_THREE_FEATURES_A_HK_SG,
    PACKAGE_THREE_FEATURES_A_MX,
    PACKAGE_TWO_FEATURES_A_MX,
    PACKAGE_TWO_FEATURES_A_US,
    TICKET_SALES_SITE,
    TR_ESSENTIALS,
} from './signupFeatures';

const noLocale = {
    [PACKAGE_COMPARISON_PAGE]: {
        showMaxFee: true,
        paymentProcessingFeature: PAYMENT_PROCESSING_US_UK_CA_AU,
    },
    [PACKAGE_ONE_PAGE]: {
        featuresExpansion: {
            processingFeesFinePrint: '',
        },
        mainHeader: {
            perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
        },
    },
    [PACKAGE_TWO_PAGE]: {
        featuresExpansion: {
            features: [
                INCLUDE_ESSENTIALS_WITH_EPP,
                DETAILED_ANALYTICS_C,
                UNLIMITED_TICKET_TYPES,
                CUSTOM_REGISTRATION,
                // PAYOUTS_B,TEMP REMOVING THIS FOR COVID-19
            ],
            processingFeesFinePrint: '',
        },
        mainHeader: {
            perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
        },
    },
    [PACKAGE_THREE_PAGE]: {
        featuresExpansion: {
            features: [
                INCLUDE_PROFESSIONAL,
                TEAM_PERMISSIONS_B,
                WHITE_LABELING_B,
                TRAINING_AND_SUPPORT_B,
            ],
        },
    },
    [PRICING_PAGE]: {
        packagesList: {
            packages: {
                [PACKAGE_ONE]: {
                    features: [
                        ...PACKAGE_ONE_FEATURES,
                        TICKET_FEES_PAYMENT_PROCESSING,
                    ],
                },
            },
            perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            finePrint: '',
        },
        faqs: {
            faqs: [
                CHANGE_PACKAGE,
                FREE_OPTION_NEW_TLDS,
                PACKAGE_DIFFER,
                PAY_FEES_NEW_TLDS,
                TICKET_TYPE,
                TICKETING_ESSENTIALS,
                PRIVATE_EVENT,
                PAYMENT_OPTIONS_NEW_TLDS,
            ],
        },
    },
};

export default {
    [AR_LOCALE]: {
        [OVERVIEW_PAGE]: {
            onsiteFeatures: {
                heading: RULE_DAYOF,
                secondaryHeading: ONSITE_PLANNING,
                features: [],
            },
            testimonials: {
                testimonials: [
                    FUNDACION_ELEGI_SONREIR,
                    CONVENCIONES_WALKERS,
                    DROVET,
                    ASISTEM_RRHH,
                    FUNDACION_MEDIAR,
                ],
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: ' + IVA',
            },
            testimonials: {
                testimonials: [CENTRO_COMERICAL, HERNAN_CASCIARI, SB_CONGRESOS],
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_ESSENTIALS,
                    CHECKOUT_WIDGET_B,
                    DETAILED_ANALYTICS_C,
                    RESERVED_SEATING,
                    UNLIMITED_TICKET_TYPES,
                    CUSTOM_REGISTRATION,
                ],
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: ' + IVA',
            },
            testimonials: {
                testimonials: [PAYONEER, TMX, OPEN_SHIMANO],
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_PROFESSIONAL,
                    INSTALLMENT_PAYMENTS,
                    TEAM_PERMISSIONS_B,
                    TRAINING_AND_SUPPORT_B,
                ],
            },
            testimonials: {
                testimonials: [THE_YOGA_EXPO, MAKER_FAIRE, NATIONAL_SAWDUST],
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_ONE]: {
                        logoImg: 'pricing/spanish--logo-basico',
                    },
                    [PACKAGE_TWO]: {
                        logoImg: 'pricing/spanish--logo-profesional',
                    },
                    [PACKAGE_THREE]: {
                        logoImg: 'pricing/logo-premium',
                    },
                },
                perPaidTicketText: ' + IVA',
                finePrint: '',
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_ONE]: {
                        logoImg: 'pricing/spanish--logo-basico',
                        features: [
                            ...PACKAGE_ONE_FEATURES,
                            TICKET_FEES_PAYMENT_PROCESSING,
                        ],
                    },
                    [PACKAGE_TWO]: {
                        logoImg: 'pricing/spanish--logo-profesional',
                    },
                    [PACKAGE_THREE]: {
                        logoImg: 'pricing/logo-premium',
                    },
                },
                perPaidTicketText: ' + IVA',
                finePrint: '',
            },
            grid: {
                packagesList: {
                    packages: {
                        [PACKAGE_THREE]: {
                            features: PACKAGE_THREE_FEATURES_A_AR_BR,
                        },
                    },
                },
                extraMainFeatures: [
                    CUSTOMER_SUPPORT,
                    TICKET_TYPES,
                    TR_ESSENTIALS,
                    LISTING_PARTNER_SITES,
                    TICKET_SALES_SITE,
                    CUSTOMIZABLE_CHECKOUT_FORMS,
                    DETAIL_SALES_ANALYTICS,
                    ONSITE_RENTAL_SUPPORT,
                    PRODUCT_TRAINING,
                ],
            },
        },
        [SIGNUP_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_THREE]: {
                        features: PACKAGE_THREE_FEATURES_A_AR_BR,
                    },
                },
            },
            extraMainFeatures: [
                CUSTOMER_SUPPORT,
                TICKET_TYPES,
                TR_ESSENTIALS,
                LISTING_PARTNER_SITES,
                TICKET_SALES_SITE,
                CUSTOMIZABLE_CHECKOUT_FORMS,
                DETAIL_SALES_ANALYTICS,
                ONSITE_RENTAL_SUPPORT,
                PRODUCT_TRAINING,
            ],
        },
    },
    [AT_LOCALE]: {
        [PRICING_PAGE]: {
            packagesList: {
                secondaryHeading: PASS_FEES_ON_SECONDARY_HEADER,
                packages: {
                    [PACKAGE_ONE]: {
                        description: ESSENTIALS_DESCRIPTION,
                        priceDescription: PRICE_DESCRIPTION,
                        features: [
                            ...PACKAGE_ONE_FEATURES,
                            TICKET_FEES_PAYMENT_PROCESSING,
                        ],
                    },
                    [PACKAGE_TWO]: {
                        description: PROFESSIONAL_DESCRIPTION,
                        priceDescription: PRICE_DESCRIPTION,
                        features: PACKAGE_TWO_GERMAN_FEATURES,
                    },
                    [PACKAGE_THREE]: {
                        description: PREMIUM_DESCRIPTION,
                        priceDescription: PRICE_DESCRIPTION,
                        features: PACKAGE_THREE_GERMAN_FEATURES,
                    },
                },
            },
        },
    },
    [AU_LOCALE]: {
        [OVERVIEW_PAGE]: {
            testimonials: {
                testimonials: [
                    RHYTHM_AND_VINES,
                    BOTTLE_SHOP_CONCEPTS,
                    THICK_AS_THIEVES,
                    BEYOND_THE_VALLEY,
                    LOVES_DATA_CONFERENCE,
                ],
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
                features: [
                    BASIC_TICKETING,
                    REPORTING_ESSENTIALS,
                    PARTNER_SITES,
                    UNLIMITED_TICKET_TYPES,
                    ORGANIZER_MOBILE_APP,
                ],
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
            testimonials: {
                testimonials: [YMCA, TED_X_MELBOURNE, BEER_INCIDER],
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
            testimonials: {
                testimonials: [THICK_AS_THIEVES, AWESOME_INC_U, ARC_FOR_UNSW],
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_PROFESSIONAL,
                    RENT_EQUIPMENT,
                    LIVE_CHAT_24_7_SUPPORT,
                    TEAM_PERMISSIONS_B,
                    WHITE_LABELING_B,
                    TRAINING_AND_SUPPORT_B,
                ],
            },
            testimonials: {
                testimonials: [
                    RHYTHM_AND_VINES,
                    BOTTLE_SHOP_CONCEPTS,
                    YAH_YAHS,
                ],
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
                packages: {
                    [PACKAGE_ONE]: {
                        features: [
                            ...PACKAGE_ONE_FEATURES_AU_V2,
                            TICKET_FEES_PAYMENT_PROCESSING,
                        ],
                    },
                },
            },
            faqs: {
                faqs: [
                    CHANGE_PACKAGE_AU,
                    TICKET_TYPE_AU,
                    FREE_OPTION_AU,
                    TICKETING_ESSENTIALS_AU,
                    PACKAGE_DIFFER_AU,
                    PRIVATE_EVENT_AU,
                    PAY_FEES_AU,
                    PAYMENT_OPTIONS_AU,
                ],
            },
        },
    },
    [BR_LOCALE]: {
        [OVERVIEW_PAGE]: {
            testimonials: {
                testimonials: [
                    CONAACUP,
                    FORRO_DA_LUA_CHEIA,
                    SENSEDIA,
                    TRIANONS,
                    COMUNIDADE_DAS_NACOES,
                ],
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
            testimonials: {
                testimonials: [CASA_COMIGO, NEW_ME, ZUM_BRAZIL_EVENTOS],
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_ESSENTIALS,
                    CHECKOUT_WIDGET_B,
                    DETAILED_ANALYTICS_C,
                    RESERVED_SEATING,
                    UNLIMITED_TICKET_TYPES,
                    CUSTOM_REGISTRATION,
                ],
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
            testimonials: {
                testimonials: [ABRADI_SP, SOCIAL_MEDIA_WEEK_SP, SUPERLOGICA],
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_PROFESSIONAL,
                    RENT_EQUIPMENT,
                    INSTALLMENT_PAYMENTS,
                    TEAM_PERMISSIONS_B,
                    TRAINING_AND_SUPPORT_B,
                ],
            },
            testimonials: {
                testimonials: [GFNY, PLUS_NETWORK, QUEREMOS],
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_THREE]: {
                        features: [
                            EVERYTHING_IN_PROFESSIONAL,
                            RENTAL_EQUIPMENT,
                            PRODUCT_TRAINING,
                        ],
                    },
                },
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
                packages: {
                    [PACKAGE_ONE]: {
                        features: [
                            ...PACKAGE_ONE_FEATURES,
                            TICKET_FEES_PAYMENT_PROCESSING,
                        ],
                    },
                },
            },
            grid: {
                packagesList: {
                    packages: {
                        [PACKAGE_THREE]: {
                            features: PACKAGE_THREE_FEATURES_A_AR_BR,
                        },
                    },
                },
                extraMainFeatures: [
                    CUSTOMER_SUPPORT,
                    TICKET_TYPES,
                    TR_ESSENTIALS,
                    LISTING_PARTNER_SITES,
                    TICKET_SALES_SITE,
                    CUSTOMIZABLE_CHECKOUT_FORMS,
                    DETAIL_SALES_ANALYTICS,
                    ONSITE_RENTAL_SUPPORT,
                    PRODUCT_TRAINING,
                ],
            },
        },
        [SIGNUP_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_THREE]: {
                        features: PACKAGE_THREE_FEATURES_A_AR_BR,
                    },
                },
            },
            extraMainFeatures: [
                CUSTOMER_SUPPORT,
                TICKET_TYPES,
                TR_ESSENTIALS,
                LISTING_PARTNER_SITES,
                TICKET_SALES_SITE,
                CUSTOMIZABLE_CHECKOUT_FORMS,
                DETAIL_SALES_ANALYTICS,
                ONSITE_RENTAL_SUPPORT,
                PRODUCT_TRAINING,
            ],
        },
    },
    [CA_LOCALE]: {
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_PROFESSIONAL,
                    RENT_EQUIPMENT,
                    LIVE_CHAT_24_7_SUPPORT,
                    INSTALLMENT_PAYMENTS,
                    TEAM_PERMISSIONS_B,
                    WHITE_LABELING_B,
                    TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_THREE]: {
                        priceDescription: gettext('Minimum threshold applies'),
                    },
                },
            },
        },
        [PRICING_PAGE]: {
            grid: {
                showFinePrint: true,
                finePrint: FINE_PRINT_WITH_FIXED_FEE,
                pricePerPaidTicket: appendFinePrintSignifier(
                    PRICE_PER_PAID_TICKET,
                ),
            },
        },
    },
    [DE_LOCALE]: {
        [OVERVIEW_PAGE]: {
            testimonials: {
                testimonials: [
                    BITS_AND_PRETZELS,
                    TECH_OPEN_AIR,
                    INTERATIONAL_GAMES_WEEK,
                    CHESS_BOXING,
                    XLETIX,
                ],
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
            testimonials: {
                testimonials: [
                    CHESS_BOXING,
                    CRESCENT_CITY_CLASSIC,
                    WEB_DIRECTIONS,
                ],
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            featureListTwo: {
                heading: gettext('Simplify operations to scale your business'),
                features: [CUSTOM_REGISTRATION, INTEGRATIONS_B],
                imagePath: `${PACKAGE_TWO}/simplify`,
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
            testimonials: {
                testimonials: [TECH_OPEN_AIR_DETAIL, DANCE_411, AWESOME_INC_U],
            },
        },
        [PACKAGE_THREE_PAGE]: {
            testimonials: {
                testimonials: [
                    XLETIX,
                    INTERATIONAL_GAMES_WEEK,
                    BITS_AND_PRETZELS_DETAIL,
                ],
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
                secondaryHeading: PASS_FEES_ON_SECONDARY_HEADER,
                packages: {
                    [PACKAGE_ONE]: {
                        description: ESSENTIALS_DESCRIPTION,
                        priceDescription: PRICE_DESCRIPTION,
                        features: [
                            ...PACKAGE_ONE_FEATURES,
                            TICKET_FEES_PAYMENT_PROCESSING,
                        ],
                    },
                    [PACKAGE_TWO]: {
                        description: PROFESSIONAL_DESCRIPTION,
                        priceDescription: PRICE_DESCRIPTION,
                    },
                    [PACKAGE_THREE]: {
                        description: PREMIUM_DESCRIPTION,
                        priceDescription: PRICE_DESCRIPTION,
                    },
                },
            },
        },
    },
    [DK_LOCALE]: {
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_ESSENTIALS_WITH_EPP,
                    DETAILED_ANALYTICS_C,
                    UNLIMITED_TICKET_TYPES,
                    CUSTOM_REGISTRATION,
                ],
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_PROFESSIONAL,
                    TEAM_PERMISSIONS_B,
                    WHITE_LABELING_B,
                    TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_ONE]: {
                        features: [
                            ...PACKAGE_ONE_FEATURES,
                            TICKET_FEES_PAYMENT_PROCESSING,
                        ],
                    },
                },
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
            faqs: {
                faqs: [
                    CHANGE_PACKAGE,
                    FREE_OPTION_NEW_TLDS,
                    PACKAGE_DIFFER,
                    PAY_FEES_NEW_TLDS,
                    TICKET_TYPE,
                    TICKETING_ESSENTIALS,
                    PRIVATE_EVENT,
                    PAYMENT_OPTIONS_NEW_TLDS,
                ],
            },
        },
    },
    [ES_LOCALE]: {
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
                packages: {
                    [PACKAGE_ONE]: {
                        features: [
                            ...PACKAGE_ONE_FEATURES,
                            TICKET_FEES_PAYMENT_PROCESSING,
                        ],
                    },
                },
            },
            grid: {
                extraMainFeatures: [CUSTOMER_SUPPORT],
            },
        },
    },
    [FI_LOCALE]: {
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_ESSENTIALS_WITH_EPP,
                    DETAILED_ANALYTICS_C,
                    UNLIMITED_TICKET_TYPES,
                    CUSTOM_REGISTRATION,
                    // PAYOUTS_B,TEMP REMOVING THIS FOR COVID-19
                ],
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_PROFESSIONAL,
                    TEAM_PERMISSIONS_B,
                    WHITE_LABELING_B,
                    TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_ONE]: {
                        features: [
                            ...PACKAGE_ONE_FEATURES,
                            TICKET_FEES_PAYMENT_PROCESSING,
                        ],
                    },
                },
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
            faqs: {
                faqs: [
                    CHANGE_PACKAGE,
                    FREE_OPTION_NEW_TLDS,
                    PACKAGE_DIFFER,
                    PAY_FEES,
                    TICKET_TYPE,
                    TICKETING_ESSENTIALS,
                    PRIVATE_EVENT,
                    PAYMENT_OPTIONS,
                ],
            },
        },
    },
    [FR_LOCALE]: {
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
                packages: {
                    [PACKAGE_ONE]: {
                        features: [
                            ...PACKAGE_ONE_FEATURES,
                            TICKET_FEES_PAYMENT_PROCESSING,
                        ],
                    },
                },
            },
        },
    },
    [GB_LOCALE]: {
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_ESSENTIALS_WITH_EPP,
                    CHECKOUT_WIDGET_B,
                    DETAILED_ANALYTICS_C,
                    RESERVED_SEATING,
                    UNLIMITED_TICKET_TYPES,
                    CUSTOM_REGISTRATION,
                    // PAYOUTS_B,TEMP REMOVING THIS FOR COVID-19
                ],
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_PROFESSIONAL,
                    RENT_EQUIPMENT,
                    LIVE_CHAT_24_7_SUPPORT,
                    TEAM_PERMISSIONS_B,
                    WHITE_LABELING_B,
                    TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                secondaryHeading: PASS_FEES_ON_SECONDARY_HEADER,
                packages: {
                    [PACKAGE_ONE]: {
                        description: ESSENTIALS_DESCRIPTION,
                        priceDescription: PRICE_DESCRIPTION,
                        features: [
                            ...PACKAGE_ONE_FEATURES,
                            TICKET_FEES_PAYMENT_PROCESSING,
                        ],
                    },
                    [PACKAGE_TWO]: {
                        description: UK_PROFESSIONAL_DESCRIPTION,
                        priceDescription: PRICE_DESCRIPTION,
                    },
                    [PACKAGE_THREE]: {
                        description: PREMIUM_DESCRIPTION,
                    },
                },
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
    },
    [DE_CH_LOCALE]: {
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_ESSENTIALS_WITH_EPP,
                    CHECKOUT_WIDGET_B,
                    DETAILED_ANALYTICS_C,
                    RESERVED_SEATING,
                    UNLIMITED_TICKET_TYPES,
                    CUSTOM_REGISTRATION,
                    // PAYOUTS_B,TEMP REMOVING THIS FOR COVID-19
                ],
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_ONE]: {
                        features: [
                            ...PACKAGE_ONE_FEATURES,
                            TICKET_FEES_PAYMENT_PROCESSING,
                        ],
                    },
                },
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
            faqs: {
                faqs: [
                    CHANGE_PACKAGE,
                    TICKET_TYPE,
                    FREE_OPTION_NEW_TLDS,
                    TICKETING_ESSENTIALS,
                    PACKAGE_DIFFER,
                    PRIVATE_EVENT,
                    PAY_FEES_NEW_TLDS,
                    PAYMENT_OPTIONS_NEW_TLDS,
                ],
            },
        },
    },
    [FR_CH_LOCALE]: {
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_ESSENTIALS_WITH_EPP,
                    CHECKOUT_WIDGET_B,
                    DETAILED_ANALYTICS_C,
                    RESERVED_SEATING,
                    UNLIMITED_TICKET_TYPES,
                    CUSTOM_REGISTRATION,
                    // PAYOUTS_B,TEMP REMOVING THIS FOR COVID-19
                ],
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_ONE]: {
                        features: [
                            ...PACKAGE_ONE_FEATURES,
                            TICKET_FEES_PAYMENT_PROCESSING,
                        ],
                    },
                },
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
            faqs: {
                faqs: [
                    CHANGE_PACKAGE,
                    TICKET_TYPE,
                    FREE_OPTION_NEW_TLDS,
                    TICKETING_ESSENTIALS,
                    PACKAGE_DIFFER,
                    PRIVATE_EVENT,
                    PAY_FEES_NEW_TLDS,
                    PAYMENT_OPTIONS_NEW_TLDS,
                ],
            },
        },
    },
    [HK_LOCALE]: {
        [OVERVIEW_PAGE]: {
            featureListOne: {
                features: [FREE_ALWAYS_FREE_FEATURE, ORGANIZER_APP_FEATURE],
            },
            onsiteFeatures: {
                heading: RULE_DAYOF,
                secondaryHeading: ONSITE_PLANNING,
                features: [],
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_ESSENTIALS,
                    CHECKOUT_WIDGET_B,
                    DETAILED_ANALYTICS_C,
                    RESERVED_SEATING,
                    UNLIMITED_TICKET_TYPES,
                    CUSTOM_REGISTRATION,
                ],
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_PROFESSIONAL,
                    TEAM_PERMISSIONS_B,
                    WHITE_LABELING_B,
                    TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_THREE]: {
                        features: [
                            EVERYTHING_IN_PROFESSIONAL,
                            BRAND_PAGES,
                            PRODUCT_TRAINING,
                        ],
                    },
                },
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_ONE]: {
                        features: [
                            ...PACKAGE_ONE_FEATURES,
                            TICKET_FEES_PAYMENT_PROCESSING,
                        ],
                    },
                },
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
            grid: {
                packagesList: {
                    packages: {
                        [PACKAGE_THREE]: {
                            features: PACKAGE_THREE_FEATURES_A_HK_SG,
                        },
                    },
                },
                extraMainFeatures: [
                    CUSTOMER_SUPPORT,
                    TICKET_TYPES,
                    TR_ESSENTIALS,
                    LISTING_PARTNER_SITES,
                    TICKET_SALES_SITE,
                    CUSTOMIZABLE_CHECKOUT_FORMS,
                    DETAIL_SALES_ANALYTICS,
                    PRODUCT_TRAINING,
                ],
            },
        },
        [SIGNUP_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_THREE]: {
                        features: PACKAGE_THREE_FEATURES_A_HK_SG,
                    },
                },
            },
            extraMainFeatures: [
                CUSTOMER_SUPPORT,
                TICKET_TYPES,
                TR_ESSENTIALS,
                LISTING_PARTNER_SITES,
                TICKET_SALES_SITE,
                CUSTOMIZABLE_CHECKOUT_FORMS,
                DETAIL_SALES_ANALYTICS,
                PRODUCT_TRAINING,
            ],
        },
    },
    [CL_LOCALE]: {
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_PROFESSIONAL,
                    INSTALLMENT_PAYMENTS,
                    TEAM_PERMISSIONS_B,
                    TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_ONE]: {
                        features: [
                            ...PACKAGE_ONE_FEATURES,
                            TICKET_FEES_PAYMENT_PROCESSING,
                        ],
                    },
                },
            },
            faqs: {
                faqs: [
                    CHANGE_PACKAGE,
                    FREE_OPTION_NEW_TLDS,
                    PACKAGE_DIFFER,
                    PAY_FEES,
                    TICKET_TYPE,
                    TICKETING_ESSENTIALS,
                    PRIVATE_EVENT,
                    PAYMENT_OPTIONS_NEW_TLDS,
                ],
            },
        },
    },
    [CO_LOCALE]: {
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_PROFESSIONAL,
                    INSTALLMENT_PAYMENTS,
                    TEAM_PERMISSIONS_B,
                    TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_ONE]: {
                        features: [
                            ...PACKAGE_ONE_FEATURES,
                            TICKET_FEES_PAYMENT_PROCESSING,
                        ],
                    },
                    [PACKAGE_THREE]: {
                        priceDescription: gettext('Minimum threshold applies'),
                    },
                },
            },
            faqs: {
                faqs: [
                    CHANGE_PACKAGE,
                    FREE_OPTION_NEW_TLDS,
                    PACKAGE_DIFFER,
                    PAY_FEES,
                    TICKET_TYPE,
                    TICKETING_ESSENTIALS,
                    PRIVATE_EVENT,
                    PAYMENT_OPTIONS_NEW_TLDS,
                ],
            },
        },
    },
    [IE_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            showMaxFee: true,
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_ESSENTIALS_WITH_EPP,
                    CHECKOUT_WIDGET_B,
                    DETAILED_ANALYTICS_C,
                    RESERVED_SEATING,
                    UNLIMITED_TICKET_TYPES,
                    CUSTOM_REGISTRATION,
                    // PAYOUTS_B,TEMP REMOVING THIS FOR COVID-19
                ],
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_PROFESSIONAL,
                    RENT_EQUIPMENT,
                    LIVE_CHAT_24_7_SUPPORT,
                    TEAM_PERMISSIONS_B,
                    WHITE_LABELING_B,
                    TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_ONE]: {
                        description: ESSENTIALS_DESCRIPTION,
                        priceDescription: PRICE_DESCRIPTION,
                        features: [
                            ...PACKAGE_ONE_FEATURES,
                            TICKET_FEES_PAYMENT_PROCESSING,
                        ],
                    },
                    [PACKAGE_TWO]: {
                        description: UK_PROFESSIONAL_DESCRIPTION,
                        priceDescription: PRICE_DESCRIPTION,
                    },
                    [PACKAGE_THREE]: {
                        description: PREMIUM_DESCRIPTION,
                    },
                },
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
    },
    [IT_LOCALE]: {
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
                packages: {
                    [PACKAGE_ONE]: {
                        features: [
                            ...PACKAGE_ONE_FEATURES,
                            TICKET_FEES_PAYMENT_PROCESSING,
                        ],
                    },
                },
            },
        },
    },
    [MX_LOCALE]: {
        [OVERVIEW_PAGE]: {
            featureListOne: {
                features: [FREE_ALWAYS_FREE_FEATURE, ORGANIZER_APP_FEATURE],
            },
            onsiteFeatures: {
                heading: RULE_DAYOF,
                secondaryHeading: ONSITE_PLANNING,
                features: [],
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_ESSENTIALS,
                    CHECKOUT_WIDGET_B,
                    DETAILED_ANALYTICS_C,
                    RESERVED_SEATING,
                    UNLIMITED_TICKET_TYPES,
                    CUSTOM_REGISTRATION,
                ],
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_PROFESSIONAL,
                    INSTALLMENT_PAYMENTS,
                    TEAM_PERMISSIONS_B,
                    TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_THREE]: {
                        priceDescription: gettext('Minimum threshold applies'),
                    },
                },
            },
            grid: {
                packagesList: {
                    packages: {
                        [PACKAGE_TWO]: {
                            features: PACKAGE_TWO_FEATURES_A_MX,
                        },
                        [PACKAGE_THREE]: {
                            features: PACKAGE_THREE_FEATURES_A_MX,
                        },
                    },
                },
                extraMainFeatures: [
                    CUSTOMER_SUPPORT,
                    TICKET_TYPES,
                    TR_ESSENTIALS,
                    LISTING_PARTNER_SITES,
                    TICKET_SALES_SITE,
                    CUSTOMIZABLE_CHECKOUT_FORMS,
                    DETAIL_SALES_ANALYTICS,
                    PRODUCT_TRAINING,
                ],
            },
        },
        [SIGNUP_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_TWO]: {
                        features: PACKAGE_TWO_FEATURES_A_MX,
                    },
                    [PACKAGE_THREE]: {
                        features: PACKAGE_THREE_FEATURES_A_MX,
                    },
                },
            },
            extraMainFeatures: [
                CUSTOMER_SUPPORT,
                TICKET_TYPES,
                TR_ESSENTIALS,
                LISTING_PARTNER_SITES,
                TICKET_SALES_SITE,
                CUSTOMIZABLE_CHECKOUT_FORMS,
                DETAIL_SALES_ANALYTICS,
                PRODUCT_TRAINING,
            ],
        },
    },
    [NL_LOCALE]: {
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
                packages: {
                    [PACKAGE_ONE]: {
                        features: [
                            ...PACKAGE_ONE_FEATURES,
                            TICKET_FEES_PAYMENT_PROCESSING,
                        ],
                    },
                },
            },
        },
    },
    [NO_LOCALE]: noLocale,
    [NZ_LOCALE]: {
        [OVERVIEW_PAGE]: {
            onsiteFeatures: {
                heading: RULE_DAYOF,
                secondaryHeading: ONSITE_PLANNING,
                features: [STAFFING_FEATURE],
            },
            testimonials: {
                testimonials: [
                    RHYTHM_AND_VINES,
                    BOTTLE_SHOP_CONCEPTS,
                    THICK_AS_THIEVES,
                    BEYOND_THE_VALLEY,
                    LOVES_DATA_CONFERENCE,
                ],
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: FINE_PRINT_WITH_FIXED_FEE_NZ,
            },
            testimonials: {
                testimonials: [YMCA, TED_X_MELBOURNE, BEER_INCIDER],
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_ESSENTIALS,
                    CHECKOUT_WIDGET_B,
                    DETAILED_ANALYTICS_C,
                    RESERVED_SEATING,
                    UNLIMITED_TICKET_TYPES,
                    CUSTOM_REGISTRATION,
                ],
                processingFeesFinePrint: FINE_PRINT_WITH_FIXED_FEE_NZ,
            },
            testimonials: {
                testimonials: [THICK_AS_THIEVES, AWESOME_INC_U, ARC_FOR_UNSW],
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_PROFESSIONAL,
                    RENT_EQUIPMENT,
                    LIVE_CHAT_24_7_SUPPORT,
                    TEAM_PERMISSIONS_B,
                    WHITE_LABELING_B,
                    TRAINING_AND_SUPPORT_B,
                ],
            },
            testimonials: {
                testimonials: [
                    RHYTHM_AND_VINES,
                    BOTTLE_SHOP_CONCEPTS,
                    YAH_YAHS,
                ],
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                finePrint: FINE_PRINT_WITH_FIXED_FEE_NZ,
            },
        },
    },
    [PE_LOCALE]: {
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_PROFESSIONAL,
                    INSTALLMENT_PAYMENTS,
                    TEAM_PERMISSIONS_B,
                    TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_ONE]: {
                        features: [
                            ...PACKAGE_ONE_FEATURES,
                            TICKET_FEES_PAYMENT_PROCESSING,
                        ],
                    },
                    [PACKAGE_THREE]: {
                        priceDescription: gettext('Minimum threshold applies'),
                    },
                },
            },
            faqs: {
                faqs: [
                    CHANGE_PACKAGE,
                    FREE_OPTION_NEW_TLDS,
                    PACKAGE_DIFFER,
                    PAY_FEES,
                    TICKET_TYPE,
                    TICKETING_ESSENTIALS,
                    PRIVATE_EVENT,
                    PAYMENT_OPTIONS_NEW_TLDS,
                ],
            },
        },
    },
    [PT_LOCALE]: {
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
                packages: {
                    [PACKAGE_ONE]: {
                        features: [
                            ...PACKAGE_ONE_FEATURES,
                            TICKET_FEES_PAYMENT_PROCESSING,
                        ],
                    },
                },
            },
        },
    },
    [SE_LOCALE]: noLocale,
    [SG_LOCALE]: {
        [OVERVIEW_PAGE]: {
            featureListOne: {
                features: [FREE_ALWAYS_FREE_FEATURE, ORGANIZER_APP_FEATURE],
            },
            onsiteFeatures: {
                heading: RULE_DAYOF,
                secondaryHeading: ONSITE_PLANNING,
                features: [],
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_ESSENTIALS,
                    CHECKOUT_WIDGET_B,
                    DETAILED_ANALYTICS_C,
                    RESERVED_SEATING,
                    UNLIMITED_TICKET_TYPES,
                    CUSTOM_REGISTRATION,
                ],
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_PROFESSIONAL,
                    TEAM_PERMISSIONS_B,
                    WHITE_LABELING_B,
                    TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_THREE]: {
                        features: [
                            EVERYTHING_IN_PROFESSIONAL,
                            BRAND_PAGES,
                            PRODUCT_TRAINING,
                        ],
                    },
                },
            },
        },
        [PRICING_PAGE]: {
            grid: {
                packagesList: {
                    packages: {
                        [PACKAGE_THREE]: {
                            features: PACKAGE_THREE_FEATURES_A_HK_SG,
                        },
                    },
                },
                extraMainFeatures: [
                    CUSTOMER_SUPPORT,
                    TICKET_TYPES,
                    TR_ESSENTIALS,
                    LISTING_PARTNER_SITES,
                    TICKET_SALES_SITE,
                    CUSTOMIZABLE_CHECKOUT_FORMS,
                    DETAIL_SALES_ANALYTICS,
                    PRODUCT_TRAINING,
                ],
            },
        },
        [SIGNUP_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_THREE]: {
                        features: PACKAGE_THREE_FEATURES_A_HK_SG,
                    },
                },
            },
            extraMainFeatures: [
                CUSTOMER_SUPPORT,
                TICKET_TYPES,
                TR_ESSENTIALS,
                LISTING_PARTNER_SITES,
                TICKET_SALES_SITE,
                CUSTOMIZABLE_CHECKOUT_FORMS,
                DETAIL_SALES_ANALYTICS,
                PRODUCT_TRAINING,
            ],
        },
    },
    [US_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            showMaxFee: true,
            paymentProcessingFeature: PAYMENT_PROCESSING_US_UK_CA_AU,
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    INCLUDE_PROFESSIONAL,
                    RENT_EQUIPMENT,
                    LIVE_CHAT_24_7_SUPPORT,
                    INSTALLMENT_PAYMENTS,
                    TEAM_PERMISSIONS_B,
                    WHITE_LABELING_B,
                    TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_TWO]: {
                        features: PACKAGE_TWO_FEATURES_ALL,
                    },
                    [PACKAGE_THREE]: {
                        features: [
                            EVERYTHING_IN_PROFESSIONAL,
                            TEAM_ACCESS,
                            RENTAL_EQUIPMENT,
                            BRAND_PAGES,
                            INSTALLMENT,
                            PRODUCT_TRAINING,
                        ],
                        priceDescription: gettext('Minimum threshold applies'),
                    },
                },
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_THREE]: {
                        features: PACKAGE_THREE_FEATURES_US,
                        priceDescription: gettext('Minimum threshold applies'),
                    },
                },
            },
            grid: {
                showFinePrint: true,
                finePrint: FINE_PRINT_WITH_FIXED_FEE,
                pricePerPaidTicket: appendFinePrintSignifier(
                    PRICE_PER_PAID_TICKET,
                ),
                packagesList: {
                    packages: {
                        [PACKAGE_TWO]: {
                            features: PACKAGE_TWO_FEATURES_A_US,
                        },
                    },
                },
                extraMainFeatures: [
                    TICKET_TYPES,
                    TR_ESSENTIALS,
                    LISTING_PARTNER_SITES,
                    TICKET_SALES_SITE,
                    CUSTOMIZABLE_CHECKOUT_FORMS,
                    DETAIL_SALES_ANALYTICS,
                    // PAYOUTS_BEFORE_EVENT,TEMP REMOVING THIS FOR COVID-19
                    ONSITE_RENTAL_SUPPORT,
                    BRANDED_PAGES,
                    PRODUCT_TRAINING,
                ],
            },
        },
        [SIGNUP_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_TWO]: {
                        features: PACKAGE_TWO_FEATURES_A_US,
                    },
                },
            },
            extraMainFeatures: [
                CUSTOMER_SUPPORT,
                TICKET_TYPES,
                TR_ESSENTIALS,
                LISTING_PARTNER_SITES,
                TICKET_SALES_SITE,
                CUSTOMIZABLE_CHECKOUT_FORMS,
                DETAIL_SALES_ANALYTICS,
                // PAYOUTS_BEFORE_EVENT,TEMP REMOVING THIS FOR COVID-19
                ONSITE_RENTAL_SUPPORT,
                BRANDED_PAGES,
                PRODUCT_TRAINING,
            ],
        },
    },
};
